import Service from './Service';

export default class TagService extends Service {
    constructor() {
        super();
        this.baseURL = 'storemanagement/tag/';
    }

}